(function () {
  var MOBILE_MQ = '(max-width: 989px)';
  /* Figma 17022:37542: la banda muestra 2 filas x 2 columnas = 4 cards. */
  var DESKTOP_ROWS = 2;
  var instances = new WeakMap();
  var observers = new WeakMap();

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function wrapperOf(root) {
    return root.querySelector('.ig-pgm__grid > .ig-pgm__swiper > .swiper-wrapper');
  }

  /* Alto exacto de las primeras DESKTOP_ROWS filas, gap incluido.
     Se mide con offsetTop/offsetHeight y no con getBoundingClientRect porque el
     scroller es absoluto y puede estar scrolleado: el rect ya vendria corrido.
     Las filas se agrupan por offsetTop en vez de asumir 2 por fila, asi un
     producto con titulo de dos lineas no descuadra el corte. */
  function measureRows(root) {
    var wrapper = wrapperOf(root);
    if (!wrapper) return 0;

    var slides = wrapper.children;
    var rows = [];

    for (var i = 0; i < slides.length; i++) {
      var el = slides[i];
      var h = el.offsetHeight;
      if (!h) continue;

      var top = el.offsetTop;
      var bottom = top + h;
      var row = null;

      for (var j = 0; j < rows.length; j++) {
        if (Math.abs(rows[j].top - top) < 2) {
          row = rows[j];
          break;
        }
      }

      if (!row) {
        rows.push({ top: top, bottom: bottom });
      } else if (bottom > row.bottom) {
        row.bottom = bottom;
      }
    }

    if (!rows.length) return 0;

    rows.sort(function (a, b) { return a.top - b.top; });
    var last = Math.min(DESKTOP_ROWS, rows.length) - 1;
    return Math.round(rows[last].bottom - rows[0].top);
  }

  /* La altura de las cards no depende de la altura de la banda (el wrapper es
     `height: auto` dentro del scroller y los tracks del grid son porcentuales),
     asi que escribir la variable no vuelve a mover lo que acabamos de medir. */
  function syncBandHeight(root) {
    var h = measureRows(root);
    if (!h) return;

    var current = parseFloat(root.style.getPropertyValue('--pgm-band-h')) || 0;
    if (Math.abs(current - h) < 1) return;

    root.style.setProperty('--pgm-band-h', h + 'px');
  }

  function observe(root) {
    if (observers.has(root) || typeof ResizeObserver === 'undefined') return;

    var wrapper = wrapperOf(root);
    if (!wrapper) return;

    /* Las fotos de las cards tienen caja fija, pero la tipografia y los swatches
       llegan tarde y mueven el alto de la fila. */
    var ro = new ResizeObserver(function () {
      if (!isMobile()) syncBandHeight(root);
    });
    ro.observe(wrapper);
    observers.set(root, ro);
  }

  function unobserve(root) {
    var ro = observers.get(root);
    if (ro) {
      ro.disconnect();
      observers.delete(root);
    }
  }

  function destroy(root) {
    var swiper = instances.get(root);
    if (swiper) {
      try { swiper.destroy(true, true); } catch (e) {}
      instances.delete(root);
    }
  }

  function createMobileSwiper(root) {
    if (typeof Swiper === 'undefined') return;
    if (instances.has(root)) return;

    var swiperEl = root.querySelector('.ig-pgm__swiper');
    if (!swiperEl) return;

    var progressEl = root.querySelector('.ig-pgm__progress');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 8,
      watchOverflow: true,
      pagination: progressEl
        ? { el: progressEl, type: 'progressbar' }
        : false,
    });

    instances.set(root, swiper);
  }

  function apply(root) {
    if (isMobile()) {
      createMobileSwiper(root);
      return;
    }

    destroy(root);
    /* `destroy(true, true)` reescribe el markup del wrapper, asi que medir en el
       mismo tick devolveria las posiciones del carrusel. */
    requestAnimationFrame(function () {
      syncBandHeight(root);
      observe(root);
    });
  }

  function initAll() {
    document.querySelectorAll('.ig-pgm').forEach(apply);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAll);
  }

  // Theme editor: re-init when the section reloads
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('.ig-pgm').forEach(apply);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('.ig-pgm').forEach(function (root) {
      destroy(root);
      unobserve(root);
    });
  });
})();
